<template>
  <div>
    <data-table ref="dataTable" :option="option">
      <template #headAction>
        <a-button type="primary" @click="add">新增</a-button>
      </template>
      <template slot="rowAction" slot-scope="text, record">
        <a-popconfirm
          placement="bottomRight"
          okText="确认"
          cancelText="取消"
          @confirm="closeNotice(text)"
          v-if="!record.IsRead"
        >
          <template slot="title">
            <p>您确认关闭通知吗？</p>
          </template>
          <a-button type="primary" size="small">关闭</a-button>
        </a-popconfirm>
      </template>
    </data-table>
    <a-modal
      title="发布消息"
      :visible="visible"
      :destroyOnClose="true"
      :maskClosable="false"
      width="1300px"
      @ok="onSubmit"
      @cancel="onCancel"
    >
      <a-row :gutter="10">
        <a-col :span="12" class="notice-form">
          <data-form
            ref="dataForm"
            :content="content"
            :colnum="2"
            :fixedLabelWidth="true"
          >
          </data-form>
        </a-col>
        <a-col :span="12">
          <div class="publish-title">
            推送门店
          </div>
          <a-row class="companys-list">
            <a-col :span="12" class="item-col">
              <h3>
                活跃门店({{ activeData.length }})
                <a-checkbox
                  class="check-all"
                  :indeterminate="indeterminate"
                  :checked="checkAll"
                  @change="onCheckAllChange"
                >
                  全选
                </a-checkbox>
              </h3>
              <a-checkbox-group v-model="checkedList" @change="onChange">
                <a-checkbox
                  v-for="item in activeData"
                  :value="item.CompanyId"
                  :key="item.CompanyId"
                >
                  {{ item.CompanyName }}
                </a-checkbox>
              </a-checkbox-group>
            </a-col>
            <a-col :span="12" class="item-col">
              <h3>
                不活跃门店({{ unActiveData.length }})
                <a-tag color="red" style="margin-left:5px">
                  7日内无订单
                </a-tag>

                <a-checkbox
                  class="check-all"
                  :indeterminate="unIndeterminate"
                  :checked="unCheckAll"
                  @change="onUnCheckAllChange"
                >
                  全选
                </a-checkbox>
              </h3>
              <a-checkbox-group
                v-model="unCheckedList"
                @change="onChangeUnActive"
              >
                <template>
                  <a-checkbox
                    v-for="item in unActiveData"
                    :value="item.CompanyId"
                    :key="item.CompanyId"
                  >
                    {{ item.CompanyName }}
                  </a-checkbox>
                </template>
              </a-checkbox-group>
            </a-col>
          </a-row>
        </a-col>
      </a-row>
    </a-modal>
  </div>
</template>
<script>
import { DataTable } from "@/components/dataTable";
import { DataForm } from "@/components/dataForm";
import { cache } from "@/utils/common";
export default {
  components: {
    DataTable,
    DataForm
  },
  data() {
    return {
      user: null,
      visible: false,
      content: [],
      checkedList: [],
      indeterminate: false,
      checkAll: false,
      unCheckedList: [],
      unIndeterminate: false,
      unCheckAll: false,
      companyOptions: [],
      activeData: [],
      unActiveData: []
    };
  },
  created() {
    this.user = cache.get("user");
    this.content = [
      {
        label: "标题",
        name: "Title",
        colnum: 2,
        option: {
          rules: [{ required: true, message: "请输入标题!" }]
        }
      },
      {
        label: "是否必读",
        name: "IsNecessary",
        type: "checkbox"
      },
      {
        label: "是否全屏推送",
        name: "IsPush",
        type: "checkbox"
      },
      {
        label: "内容",
        name: "Content",
        type: "textarea",
        colnum: 2,
        option: {
          rules: [{ required: true, message: "请输入内容!" }]
        },
        isStopTab: true
      }

      // {
      //   label: " ",
      //   colon: false,
      //   colnum: 2,
      //   slot: "companys"
      // }
    ];
    this.option = {
      // headSearch: {
      //   colnum: 1,
      //   content: [
      //     {
      //       label: "门店名称",
      //       name: "Name"
      //     }
      //   ]
      // },
      grid: {
        api: "GetNotice",
        dataField: "Data",
        pagination: false,
        props: {
          scroll: {
            x: 1200,
            y: "calc(100vh - 300px)"
          }
        },
        columns: [
          {
            title: "序号",
            width: "50px",
            align: "center",
            type: "indexcolumn"
          },
          {
            title: "标题",
            width: 250,
            dataIndex: "Title"
          },
          {
            title: "是否关闭",
            width: 130,
            dataIndex: "IsRead",
            customRender: text => {
              if (text) {
                return <a-badge status="success" text="是" />;
              } else {
                return <a-badge status="error" text="否" />;
              }
            }
          },
          {
            title: "是否必须查阅",
            width: 130,
            dataIndex: "IsNecessary",
            customRender: text => {
              if (text) {
                return <a-badge status="success" text="是" />;
              } else {
                return <a-badge status="error" text="否" />;
              }
            }
          },
          {
            title: "是否全屏弹窗",
            width: 130,
            dataIndex: "IsPush",
            customRender: text => {
              if (text) {
                return <a-badge status="success" text="是" />;
              } else {
                return <a-badge status="error" text="否" />;
              }
            }
          },
          {
            title: "内容",
            dataIndex: "Content",
            customRender: text => {
              const arr = text.split("\n");
              let str = [];
              arr.forEach(el => {
                str.push(<p>{el}</p>);
              });
              return <div>{str}</div>;
            }
          },
          {
            title: "操作",
            dataIndex: "Id",
            width: 130,
            scopedSlots: { customRender: "rowAction" }
          }
        ]
      }
    };
    this.$post("GetCompanyOutput", {}).then(res => {
      this.companyOptions = res.Data;
      this.activeData = this.companyOptions.filter(v => v.IsActive);
      this.unActiveData = this.companyOptions.filter(v => !v.IsActive);
    });
  },
  methods: {
    onChange(checkedList) {
      this.indeterminate =
        !!checkedList.length && checkedList.length < this.companyOptions.length;
      this.checkAll = checkedList.length === this.companyOptions.length;
    },
    onChangeUnActive(checkedList) {
      this.unIndeterminate =
        !!checkedList.length && checkedList.length < this.unActiveData.length;
      this.unCheckAll = checkedList.length === this.unActiveData.length;
    },
    onCheckAllChange(e) {
      Object.assign(this, {
        checkedList: e.target.checked
          ? this.activeData.map(v => v.CompanyId)
          : [],
        indeterminate: false,
        checkAll: e.target.checked
      });
    },
    onUnCheckAllChange(e) {
      Object.assign(this, {
        unCheckedList: e.target.checked
          ? this.unActiveData.map(v => v.CompanyId)
          : [],
        unIndeterminate: false,
        unCheckAll: e.target.checked
      });
    },
    add() {
      this.checkedList = [];
      this.unCheckedList = [];
      this.checkAll = false;
      this.unCheckAll = false;
      this.indeterminate = false;
      this.unIndeterminate = false;
      this.visible = true;
      this.$nextTick(() => {
        this.$refs.dataForm.setData({
          IsPush: false,
          IsNecessary: false
        });
      });
    },
    closeNotice(id) {
      this.$post("CloseNotice", {
        Id: id
      }).then(() => {
        this.$message.success("操作成功");
        this.$refs.dataTable.reload();
      });
    },
    onSubmit() {
      this.$refs.dataForm.form.validateFields((err, values) => {
        if (!err) {
          let companyIds = this.checkedList.concat(this.unCheckedList);
          if (!companyIds.length) {
            this.$message.error("请选择推送门店");
            return false;
          }
          this.companyOptions.forEach(el => {
            if (
              companyIds.includes(el.CompanyId) &&
              !companyIds.includes(el.GroupId)
            ) {
              companyIds.push(el.GroupId);
            }
          });

          this.$post("PushNotice", {
            ...values,
            CompanyIds: companyIds
          }).then(() => {
            this.$message.success("发布成功");
            this.visible = false;
            this.$refs.dataTable.reload();
          });
        }
      });
    },
    onCancel() {
      this.visible = false;
    }
  }
};
</script>

<style lang="less" scoped>
.companys-list {
  padding: 10px;
  border: 1px solid #eee;
  border-top: 0;
  /deep/ .ant-checkbox-wrapper {
    margin-left: 0;
    display: inline-block;
    width: 290px;
    height: 22px;
    line-height: 22px;
    overflow: hidden;
  }
  .item-col {
    height: calc(100vh - 360px);
    overflow: hidden;
    overflow-y: auto;
    position: relative;

    h3 {
      border-bottom: 1px solid #eee;
      width: 96%;
      margin-bottom: 8px;
      padding-bottom: 8px;
      color: #333;
      font-size: 16px;
    }
    .check-all {
      width: 65px;
      position: absolute;
      right: 15px;
      top: 8px;
      border-bottom: 0;
    }
    &:first-child::after {
      content: "";
      position: absolute;
      right: 15px;
      height: calc(100vh - 360px);
      width: 1px;
      background: #ddd;
      top: 0;
    }
  }
}
.publish-title {
  padding: 0 10px;
  background: #e6f3ff;
  line-height: 30px;
  color: #000;
  .ant-checkbox-wrapper {
    float: right;
  }
}
.notice-form /deep/form textarea.ant-input {
  height: calc(100vh - 390px);
}
</style>
